<template>
<loader v-bind="{ loading }">
  <div class="columns">
    <div class="column is-narrow">
      <router-link
        v-if="$root.can('create_audits', app.account_id)"
        class="is-flex"
        :to="{
          name: 'new-audit',
          params: {
            app: $route.params.app
          }
        }">
        <icon icon="plus"/>
        <span>Audit</span>
      </router-link>
    </div>
  </div>
  <div class="columns">
    <div class="column">
      <index-row 
        v-for="audit in audits.data" :key="audit.id"
        :title="`#${audit.number} ${ audit.standard.name}`"
        :route="{
          name: 'audit-manager',
          params: {
            audit: audit.id
          }
        }"
      >
        <span class="has-text-weight-light">{{ audit.environment.name }}</span>
        <span class="help">{{ audit.updated_at | asCalendar }}</span>

        <template #right>
          <flex column class="has-text-centered">
            <span>{{ audit.compliance_percentage }}%</span>
            <span>Compliance</span>
          </flex>
          <flex column class="has-text-centered">
            <span>{{ audit.unresolved_findings_count }}</span>
            <span>Findings</span>
          </flex>
          <flex>
            <current-status :statuses="audit.statuses" />
          </flex>
        </template>
      </index-row>

      <pager v-if="audits.next_page_url || audits.prev_page_url" context="audit" :pageable="audits" @nav="goTo"/>
        
      <no-items-to-show v-if="!audits.data.length && !audits.total" text="No Audits Found">
        <router-link
          :to="{ name: 'create-audit' }"
          class="is-rounded button">
          <icon icon="plus"/>
          <span>Start an Audit</span>
        </router-link>
      </no-items-to-show>  
    </div>
  </div>
</loader>
</template>

<script>
import { mapGetters } from 'vuex'
import Paginator from '@/store/models/Paginator'
import { getPath } from '@/api/common'

export default {

  data: () => ({
    loading: true,
    audits: new Paginator
  }),

  beforeCreate() {
    this.$bus.$emit('set-title', 'Audits')
  },

  created() {
    this.loadAudits()
  },

  methods: {
    loadAudits() {
      getPath({
        path: 'api' + this.$route.fullPath
      }, ({data}) => {
        this.audits = data
        this.loading = false
      })
    }
  },

  computed: {
    ...mapGetters('app', [
      'app'
    ])
  },

  watch: {
    '$route': 'loadAudits'
  }
}
</script>
